import React from 'react'
import './App.css'
import Display from './Display'

function App() {
    return (
        <div className="container">
            <Display />
        </div>
    )
}

export default App
